var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.version && _vm.occupied_space)?_c('div',[_vm._v("\n    Versão "),_c('span',{staticClass:"blue-mds"},[_vm._v(_vm._s(_vm.version))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }